import { observer } from "mobx-react-lite";
import { EmptyContainer, EmptyText } from "@/components/styling/empty";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import EmptyCollectionsImage from "@/assets/images/empty-collections.svg?react";
import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import { MDSButton, MDSButtonVariant } from "@/mds";

export const CollectionViewPageListEmpty = observer(function CollectionViewPageListEmpty() {
  const page = useTabPageStore("collectionsViewPage");
  const canWrite =
    !page.collectionObservable?.isDeleted && page.collectionObservable?.canWrite == true;

  if (page.filters.hasAnyFilters) {
    return (
      <EmptyContainer>
        <EmptySearchImage />
        <EmptyText>No results match your selected filters</EmptyText>
        <MDSButton onClick={() => page.filters.clearAllFilters()}>Clear filters</MDSButton>
      </EmptyContainer>
    );
  }

  return (
    <EmptyContainer>
      <EmptyCollectionsImage />
      <EmptyText>No notes in this collection yet</EmptyText>
      {canWrite && (
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={() => page.handleCreateNewNote()}>
          Create note in this collection
        </MDSButton>
      )}
    </EmptyContainer>
  );
});
